import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

// Org Firebase project (possosmarthireorg)
const orgFirebaseConfig = {
  apiKey: 'AIzaSyDxAU0hhvjael-BcLuzUoK_bZc7Rg6ydCE',
  authDomain: 'orgauth.possobuild.ai',
  projectId: 'possosmarthireorg',
  storageBucket: 'possosmarthireorg.appspot.com',
  messagingSenderId: '727609398872',
  appId: '1:727609398872:web:d89170d24e47b4b861dc2d',
  measurementId: 'G-6M13NWSD12',
}

// Candidate Firebase project (posso-build)
const candidateFirebaseConfig = {
  apiKey: 'AIzaSyDv_UiZX3US-VWKo2TTwzEN_gDBC6NBto4',
  authDomain: 'candidatesignin.possobuild.ai',
  projectId: 'posso-build',
  storageBucket: 'posso-build.appspot.com',
  messagingSenderId: '216949993766',
  appId: '1:216949993766:web:fbe2c739a954f4217e51e7',
}

const orgApp = initializeApp(orgFirebaseConfig, 'smarthire-org')
const candidateApp = initializeApp(candidateFirebaseConfig, 'smarthire-candidate')

export const orgAuth = getAuth(orgApp)
export const candidateAuth = getAuth(candidateApp)

export const SMARTHIRE_API = import.meta.env.VITE_API_SERVER
const APP_BASE = import.meta.env.VITE_SMARTHIRE_APP_URL
export const ORG_DASHBOARD = `${APP_BASE}/organization`
export const ORG_SETTINGS = `${APP_BASE}/organization/settings`
export const CANDIDATE_DASHBOARD = `${APP_BASE}/aspirant`

/** Check if user has an active session (cookie-based) */
export async function checkLogin() {
  try {
    const res = await fetch(`${SMARTHIRE_API}/check_login`, { credentials: 'include' })
    const data = await res.json()
    if (data.result === 'success') {
      return { name: data.name, email: data.email, picture: data.picture, userType: data.userType }
    }
    return null
  } catch {
    return null
  }
}

/** Destroy the backend session */
export async function sessionLogout() {
  try {
    await fetch(`${SMARTHIRE_API}/session_logout`, { method: 'POST', credentials: 'include' })
  } catch { /* ignore */ }
}
